import { __rest } from 'tslib';
import React from 'react';
import { styled, LazyImage, Overlay } from '@teko/ui';

var loading = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20style%3D%22margin%3A%20auto%3B%20background%3A%20none%3B%20display%3A%20block%3B%20shape-rendering%3A%20auto%3B%22%20width%3D%22150px%22%20height%3D%22150px%22%20viewBox%3D%220%200%20100%20100%22%20preserveAspectRatio%3D%22xMidYMid%22%3E%3Cpath%20d%3D%22M10%2050A40%2040%200%200%200%2090%2050A40%2042%200%200%201%2010%2050%22%20fill%3D%22%237dd2eb%22%20stroke%3D%22none%22%20transform%3D%22rotate%28339.278%2050%2051%29%22%3E%20%20%3CanimateTransform%20attributeName%3D%22transform%22%20type%3D%22rotate%22%20dur%3D%221s%22%20repeatCount%3D%22indefinite%22%20keyTimes%3D%220%3B1%22%20values%3D%220%2050%2051%3B360%2050%2051%22%3E%3C%2FanimateTransform%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

const Wrapper = styled.div((props) => `
    width: ${props.size}px;
    height: ${props.size}px;
    position: relative;
  `);
const Logo = styled(LazyImage) `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
const StyledLazyImage = styled(LazyImage) `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 3px;
  right: 0;
`;
const LogoLoading = (_a) => {
    var { size = 80, logo = '' } = _a, props = __rest(_a, ["size", "logo"]);
    return (React.createElement(Wrapper, Object.assign({}, props, { size: size }),
        logo && React.createElement(Logo, { width: size / 2, height: size / 2, src: logo }),
        React.createElement(StyledLazyImage, { width: size, height: size, src: loading })));
};

const StyledOverLay = styled(Overlay) `
  background: rgba(0, 0, 0, 0.03);
`;
const Loading = (_a) => {
    var { isLoading, children, logo } = _a, props = __rest(_a, ["isLoading", "children", "logo"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledOverLay, Object.assign({}, props, { show: isLoading }),
            React.createElement(LogoLoading, { logo: logo })),
        children));
};

export { Loading as L, LogoLoading as a };
